<div class="errorState">
    <mat-icon [svgIcon]="'heroicons_outline:exclamation-circle'"></mat-icon>
    <h3>{{errorDescription}}</h3>
</div>